// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Tabs-Tab-module--cls1--1bFP_","active":"Tabs-Tab-module--active--5WBT1"};